import moment from 'moment';

export function normalizeToFullYear(year: string | null): number {
  const yearNum = Number(year);
  return yearNum < 50 ? 2000 + yearNum : yearNum < 100 ? 1900 + yearNum : yearNum;
}

export const slug = (value: string): string => {
  if (!value) {
    return '';
  }
  return value.toLowerCase().replace(/ /g, '-');
};

// Deprecated
export const formatCurrency = (value: string | number) => {
  if (typeof value === 'number') {
    value = value.toString();
  } else if (!value) {
    value = '';
  }
  const hasCents = value.split('.').length > 1;
  let cents = '';
  if (hasCents) {
    const splitValue = value.split('.');
    cents = splitValue[1];
    value = splitValue[0];
  }
  const chars = value.split('').reverse();
  const withCommas = [];
  for (let i = 1, l = chars.length; i <= l; i += 1) {
    withCommas.push(chars[i - 1]);
    if (i % 3 === 0 && i !== chars.length) {
      withCommas.push(',');
    }
  }
  return `${withCommas.reverse().join('')}${hasCents ? `.${cents}` : ''}`;
};

export const getDateRangeInFullFormat = (startDateMs?: number, endDateMs?: number): string => {
  if (!startDateMs || !endDateMs) {
    return '';
  }

  const startDate = moment(startDateMs);
  const endDate = moment(endDateMs);

  if (!startDate.isValid() || !endDate.isValid()) {
    return '';
  }

  const formatDate = startDate.format('dddd, MMMM DD, YYYY');
  const formatTime = `${startDate.format('hh:mma')} - ${endDate.format('hh:mma')}`;
  const formatTz = startDate.format('Z');

  return `${formatTime} (GMT${formatTz}) on ${formatDate}`;
};
